// React imports.
import React, { Component } from "react";

// App imports.
import Breadcrumbs from "./Breadcrumbs";
import { GuidedSearchReportTypes } from "../utility";


const ChooseStates = ({ state, breadCrumbsCurrentStep }) => (
     <React.Fragment>
          <Breadcrumbs currentStep={breadCrumbsCurrentStep} />
          <fieldset>
               <legend>Choose states to report on</legend>

               {state.SelectedReportType == GuidedSearchReportTypes.singleState
                    &&
                    <React.Fragment>
                         <label htmlFor="selSingleStateGrantees">
                              States:
                         </label>

                         <select
                              id="SelectedGranteeId"
                              defaultValue={state.SelectedGranteeId}
                              onChange={state.chooseStatesFieldChangeHandler}>
                              <option >Choose a state</option>
                              {state.Grantees.slice(1).map(grantee => {
                                   return (
                                        <option key={grantee.granteeId} value={grantee.granteeId}>{grantee.granteeName}</option>
                                   );
                              })}
                         </select>
                    </React.Fragment>
               }
               {state.SelectedReportType == GuidedSearchReportTypes.stateComparison
                    &&
                    <React.Fragment>
                         <div className="leftFloatingDiv oneThirdWidth">
                              <strong>States:</strong>
                              <div className="round-border-div" style={{ "height": "200px" }}>
                                   <div style={{ "clear": "both" }}>
                                        {state.Grantees.slice(1).map(grantee => {
                                             return (
                                                  <label className="pointer" htmlFor="selCompareGranteesSelect..." onClick={clickEvent => state.granteeRadioClicked(grantee.granteeId)}>
                                                       <input className="granteeCheckbox"
                                                            type="checkbox"
                                                            value={grantee.granteeId}
                                                            id={'selCompareGrantees' + grantee.granteeId}
                                                            
                                                            checked={state.SelectedGranteeIds.indexOf(grantee.granteeId) > -1}
                                                       />
                                                       {grantee.granteeName}
                                                  </label>
                                             );
                                        })}
                                   </div>
                              </div>
                         </div>
                         <div className="leftFloatingDiv oneThirdWidth">
                              <label htmlFor="btnClearGrantees">You have selected:&nbsp;&nbsp;
                                   <a href="#" id="btnClearGrantees">Clear all</a>
                              </label>
                              <ol className="round-border-div" style={{ "height": "200px" }}>
                                        {state.SelectedGranteeIds.map(gid => {
                                        return (
                                             <li>
                                                  {state.getGranteeName(gid)}
                                                  <a href="#" onClick={clickEvent =>state.removeSelectedGrantee(gid)} >[X]</a>
                                             </li>

                                        );
                                   })}
                              </ol>
                         </div>
                    </React.Fragment>
               }
               <br /><br />
               <div style={{ "clear": "both" }}>
                    <button className="dataButton " onClick={state.chooseStatesNext}>Next</button>
                    <button className="dataButton " onClick={state.chooseStatesBack}>Back one step</button>
               </div>
          </fieldset>
     </React.Fragment>
);

export default ChooseStates;
